import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { ReferenceDataTypes } from "@enums/reference-data-types";
import { ReferenceDataSourceTypes } from "@enums/reference-data-source-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { getQueryParamValueFromReferenceDataArray } from "@utils/string-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { CommonReferenceData } from "@idw-types/state/common-reference-data-state";


export const getReferenceDataRequest = async (
    referenceDataTypes: Array<ReferenceDataTypes>,
    referenceDataSource: ReferenceDataSourceTypes
): Promise<GenericNetworkResponse<Partial<CommonReferenceData>>> => {
    let route = apiRoutes.serviceConfiguration.referenceData;
    
    switch(referenceDataSource) {
        case ReferenceDataSourceTypes.AXNADMIN_CORE:
            route = apiRoutes.axnadminCore.referenceData;
            break;
        case ReferenceDataSourceTypes.REPORTS:
            route = apiRoutes.reports.referenceData;
            break;
        case ReferenceDataSourceTypes.SERVICE_CONFIGURATION:
            route = apiRoutes.serviceConfiguration.referenceData;
            break;
        case ReferenceDataSourceTypes.IDP_CONFIGURATION:
            route = apiRoutes.idpConfiguration.referenceData;
            break;
        case ReferenceDataSourceTypes.ALERTS:
            route = apiRoutes.alerts.referenceData;
            break;
        case ReferenceDataSourceTypes.MANAGEMENT_CONSOLE:
            route = apiRoutes.managementConsole.referenceData;
            break;
    }

    const queryParamValue = getQueryParamValueFromReferenceDataArray(referenceDataTypes);

    const queryParameters: Array<QueryParameter> = [{
        parameter: "dataTypes",
        value: queryParamValue
    }];

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error, queryParameters };
};